import { useState, useEffect } from 'react'

function getStorageValue(key, defaultValue) {
  // getting stored value
  const saved = window.localStorage.getItem(key)

  if (saved === null) {
    return defaultValue
  }
  const initial = JSON.parse(saved)

  return initial || defaultValue
}

export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue)
  })

  useEffect(() => {
    // storing input name
    window.localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValue]
}
